module.exports = __webpack_public_path__ + "static/media/hsag-logo-take2.35b722be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/hsag-logo-take2.jpg
// module id = 863
// module chunks = 0